import { HttpClient } from '@angular/common/http';
import { Observable, of, shareReplay } from 'rxjs';
import { environment } from './../../environments/environment';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { User } from '../models/user';

@Injectable({ providedIn: 'root' })
export class UserService {
  private usersCache: User[] = [];
  private usersRequest$: Observable<User[]> | null = null;

  constructor(public http: HttpClient) { }

  getUsers(): Observable<User[]> {
    if (this.usersCache?.length > 0) {
      return of(this.usersCache);
    }
    if (!this.usersRequest$) {
      const url = `${environment.apiUrl}users/summary`;
      this.usersRequest$ = this.http.get<User[]>(url).pipe(
        tap((users) => { this.usersCache = users; }),
        shareReplay(1)
      );
    }
    return this.usersRequest$;
  }

  /** Resolves a user ID to "firstName lastName". Falls back to the raw value if not found. */
  resolveUserId(id: string): string {
    if (!id) return '';
    const user = this.usersCache.find(u => u.id === id);
    return user ? `${user.firstName} ${user.lastName}` : id;
  }

  getFullUsers(): Observable<User[]> {
    const url = `${environment.apiUrl}users`;
    return this.http.get<User[]>(url);
  }

  patchUserField(userId: string, fieldName: string, newValue: any): Observable<void> {
    const url = `${environment.apiUrl}users/${userId}`;
    return this.http.patch<void>(url, { fieldName, newValue });
  }

  updateUser(modifiedUser: User): Observable<User> {
    const url = `${environment.apiUrl}users`;
    return this.http.patch<User>(url, modifiedUser);
  }

  deleteUser(userId: string): Observable<void> {
    const url = `${environment.apiUrl}users/${userId}`;
    this.usersCache = [];
    return this.http.delete<void>(url);
  }

}
